
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import NotFound from "./pages/NotFound";
import HomePage from "./pages/HomePage";
import DoctorPage from "./pages/DoctorPage";
import HospitalPage from "./pages/HospitalPage";
import PatientPage from "./pages/PatientPage";
import InsurancePage from "./pages/InsurancePage";
import AuthPage from "./pages/AuthPage";
import StaffPage from "./pages/StaffPage";
import AdminPage from "./pages/AdminPage";
import React from "react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Create App component with proper nesting of providers
const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <BrowserRouter>
          <Toaster />
          <Sonner />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/doctor" element={
              <ProtectedRoute roles={["doctor"]}>
                <DoctorPage />
              </ProtectedRoute>
            } />
            <Route path="/hospital" element={
              <ProtectedRoute roles={["hospital"]}>
                <HospitalPage />
              </ProtectedRoute>
            } />
            <Route path="/patient" element={
              <ProtectedRoute roles={["patient"]}>
                <PatientPage />
              </ProtectedRoute>
            } />
            <Route path="/insurance" element={
              <ProtectedRoute roles={["insurance"]}>
                <InsurancePage />
              </ProtectedRoute>
            } />
            <Route path="/staff" element={
              <ProtectedRoute roles={["staff"]}>
                <StaffPage />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute roles={["admin"]}>
                <AdminPage />
              </ProtectedRoute>
            } />
            <Route path="*" element={<NotFound />} />
          </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
